import { $translate } from '@/utils/i18n';
export default {
    'manageNews': {
        'labelWidth': '100px',
        'inputWidth': '100px',
        'labelList': [
            {
                'name': $translate('lang.E3202103100001', { defaultText: '集群名称' })
            },
            {
                'name': $translate('lang.E3202103100002', { defaultText: '协议' })
            },
            {
                'name': $translate('lang.E3202103100003', { defaultText: '用户名' })
            },
            {
                'name': $translate('lang.E3202103100006', { defaultText: '密码' })
            }
        ],
        'options': [
            {
                'value': 'HTTP',
                'label': 'HTTP'
            },
            {
                'value': 'HTTPS',
                'label': 'HTTPS'
            }
        ]
    },
    'newDelate': {
        'inputHolder': $translate('lang.E3202103100001', { defaultText: '集群名称' }),
        'btnType': 'primary',
        'dialogWidth': '30%',
        'dialogTitle': $translate('lang.E3202103100030', { defaultText: 'ES集群配置-新增' })
    },
    'mangeTable': {
        'dialogTitle': [
            {
                'name': $translate('lang.E3202103100014', { defaultText: 'ES集群配置' })
            },
            {
                'name': $translate('lang.E3202103100029', { defaultText: 'ES集群绑定' })
            },
            {
                'name': $translate('lang.E3202103100007', { defaultText: 'ES集群配置地址修改' })
            }
        ]
    },
    'modificationAddress': {
        'labelList': [
            $translate('lang.E3202103100009', { defaultText: '地址' }),
            $translate('lang.E3202103100010', { defaultText: '端口' }),
            $translate('lang.E3202101250007', { defaultText: '操作' })
        ]
    }
};